























import { Component, Vue } from 'vue-property-decorator'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { BaseStore, KfDataType } from '@/store/modules/Base'
import { loadCustomService } from '@/api/user'

@Component({
  name: 'KF'
})
export default class KF extends Vue {
  private get kfData (): KfDataType {
    return BaseStore.kfData
  }

  get userInfo (): userInfoTypes {
    return UserStore.userInfo
  }

  getLoadCustomService () {
    const params = {
      custServiceId: this.userInfo.customServiceId
    }
    loadCustomService(params)
      .then(res => {
        if (res.success) {
          BaseStore.SET_SERVICE(res.data)
        }
      })
  }

  mounted (): void {
    this.getLoadCustomService()
  }
}

